import { Component } from '@angular/core';
import { OA_ADMIN_AREA } from '@markant-platform/shared/guided-tour';
import { PlatformWidgetComponent } from '../../platform-widget.component';

@Component({
  selector: 'markant-platform-guided-tour-admin-area',
  templateUrl: './guided-tour-admin-area.component.html',
})
export class GuidedTourAdminAreaComponent extends PlatformWidgetComponent {
  readonly OA_ADMIN_AREA = OA_ADMIN_AREA;
}
